import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const UserProfile = styled.div`
	display: flex;
	min-width: 25rem;
	justify-content: space-between;
	padding: 1.6rem;
`;

export const UserProfileLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-l);
`;

export const UserProfileRight = styled.div`
	position: relative;
	width: 4.8rem;
	height: 4.8rem;
	flex-shrink: 0;
	& > * {
		width: 100%;
		height: 100%;
	}
`;

export const avatarStyles = css`
	width: 3.8rem;
	height: 3.8rem;
	font-size: var(--font-size-m);
`;

export const TileElement = css`
	border-radius: var(--radius-xs);
	backdrop-filter: blur(28px);
	background-color: var(--color-white-xxs);
	margin-inline: 1.2rem;
	padding-inline: 1.6rem;
`;

export const SubscriptionDropdownElement = css`
	display: flex;
	flex-direction: column;
	margin-bottom: 1.2rem;
	gap: var(--gap-m);
`;

// selector с высокой специфичностью чтобы "перевесить" селектор в DropdownElement
// Цвет Discord, не в нашей палитре
export const ConnectDiscordDropdownElement = css`
	margin-bottom: 0.8rem;

	svg {
		height: 3.8rem;

		& rect[fill] {
			fill: #5865f2;
		}
		& path[fill] {
			fill: var(--color-white-solid);
		}
	}
`;
